export const position = {
	1: 'end',
	2: 'center',
	3: 'start',
};
